import { render, staticRenderFns } from "./AddressInputGroup.vue?vue&type=template&id=045d9984&"
import script from "./AddressInputGroup.vue?vue&type=script&lang=js&"
export * from "./AddressInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports